module.exports = __webpack_public_path__ + "img/wulianwang (2).420ea639.png";